export default "__VITE_ASSET__BnoYFirc__"